module.exports = __webpack_public_path__ + "img/Banner_Mobile_Fin_Promo.40ea6595.png";